import CustomFormatNumber from "components/CustomFormatNumber";
import React from "react";

// Button for Sell and buy order
function TradingOfferButton({ title, value, type, isShowActiveBtnClass = true, className = "", onClick = () => {} }) {
    return (
        <button
            className={`mb-0 ${isShowActiveBtnClass ? "action-btn" : ""} ${type == "sell" ? "btn-sell" : ""} ${className}`}
            onClick={onClick}
        >
            {value ? <CustomFormatNumber className="text-16 mr-2 pr-2 border-right" value={value} symbol="€" /> : null}
            {title}
        </button>
    );
}

export { TradingOfferButton };
